import { Routes } from "@angular/router";

export const savingForPensionLazyRoutes: Routes = [
  {
    path: "",
    loadComponent: () => import("./saving-for-pension-page.component").then((c) => c.SavingForPensionPageComponent),
  },
];
